import Image from "next/image";

import ChevronRightIcon from "@repo/ui-system/icons/arrows/chevron-right/outline.svg";

import { OutboundLink } from "@/features/outbound-link/outbound-link";
import { type BestQuickPicksItem } from "@/lib/api/best/quick-picks/schema";
import { BiEvent } from "@/lib/bi/bi.enum";

type Props = {
  item: BestQuickPicksItem;
};

export function QuickPickCard({ item }: Props) {
  return (
    <OutboundLink
      url={item.url}
      storeName="amazon"
      bi={{
        eventType: BiEvent.BannerOutbound,
        id: String(item.id),
        provider: "amazon",
        location: "quick-picks",
      }}
      target="_blank"
      rel="noopener noreferrer"
      className="group flex flex-col"
    >
      <div className="relative z-2 -mb-3 pl-4">
        <span className="mini3 rounded bg-primary px-1 py-0.5 text-text-grayscale-negative">
          {item.label}
        </span>
      </div>

      <div className="flex flex-1 gap-4 rounded-2xl border border-border-grayscale-default p-5 transition-all duration-300 ease-out group-hover:border-border-grayscale-darker group-hover:bg-[#F9F9F9]">
        <div className="flex shrink-0 items-center bg-white rounded-xl">
          <Image
            src={item.image}
            alt={item.name}
            width={88}
            height={88}
            sizes="88px"
            className="size-[88px] object-contain mix-blend-multiply"
          />
        </div>

        <div className="flex min-w-0 flex-1 flex-col gap-4">
          <div className="flex flex-1 flex-col gap-2">
            <div className="flex flex-col gap-2">
              <p className="sub1 h-[2lh] line-clamp-2 text-text-grayscale-title">
                {item.title}
              </p>
              <p className="mini2 truncate text-text-grayscale-caption">
                {item.name}
              </p>
            </div>
            <p className="body2 text-text-grayscale-body h-[2lh] line-clamp-2">
              {item.description}
            </p>
          </div>
          <span className="body1 flex items-center gap-2 text-text-primary-default underline hover:text-[#245c90]">
            Check on Amazon
            <ChevronRightIcon className="size-4 shrink-0" />
          </span>
        </div>
      </div>
    </OutboundLink>
  );
}
